import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { Card } from "@/components/ui-helpers";
import { toast } from "sonner";
import { FileSignature } from "lucide-react";

// Admin list of client-signed retainers still waiting for the RCIC countersignature.
export function CountersignQueue() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/retainers-awaiting-countersign").then((r) => setItems(r.data)).catch(() => setItems(null));
  useEffect(() => { load(); }, []);
  if (!items) return null;
  const sign = async (r) => {
    if (!window.confirm(`Countersign retainer v${r.version} for ${r.client_name}?`)) return;
    setBusy(r.id);
    try { await api.post(`/retainers/${r.id}/countersign`); toast.success("Countersigned — fully executed PDF saved to the case"); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  return (
    <Card className="p-5 mb-6" data-testid="countersign-queue">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-head font-bold text-slate-900 inline-flex items-center gap-2"><FileSignature className="h-4 w-4 text-primary" /> Retainers awaiting RCIC countersignature</h3>
        <span className="text-xs font-bold bg-amber-100 text-amber-700 rounded-full px-2 py-0.5" data-testid="countersign-count">{items.length}</span>
      </div>
      {items.length === 0 ? <p className="text-sm text-slate-400">Nothing waiting — all client-signed retainers are countersigned.</p> : (
        <div className="divide-y divide-slate-100">
          {items.map((r) => (
            <div key={r.id} className="flex flex-wrap items-center gap-3 py-2.5" data-testid={`countersign-row-${r.id}`}>
              <div className="min-w-0 flex-1">
                <Link to={`/admin/applications/${r.application_id}?tab=retainer`} className="font-semibold text-slate-800 hover:text-primary">{r.client_name}</Link>
                <div className="text-xs text-slate-500">{r.app_number} · {r.service} · v{r.version} · signed by {r.signed_by} on {(r.signed_at || "").slice(0, 10)}</div>
              </div>
              {r.can_countersign
                ? <button data-testid={`countersign-btn-${r.id}`} onClick={() => sign(r)} disabled={busy === r.id} className="bg-primary text-white px-3 py-1.5 rounded-lg text-xs font-semibold disabled:opacity-50">{busy === r.id ? "Signing…" : "Countersign"}</button>
                : <span className="text-[11px] text-amber-700">Signed before countersigning existed — resend</span>}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
